import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ClientSourceForm from './ClientSourceForm';

const ClientSourceActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ClientSourceCreate = (props: any) => {
  return (
    <Create actions={<ClientSourceActions {...props} />} {...props}>
      <ClientSourceForm />
    </Create>
  );
};

export default ClientSourceCreate;
